import { createContext, useContext, type ReactNode } from 'react';

/** Varsayılan ret: yalnız /me yanıtında verilen eylemler sunulur. */
export const CapabilitiesContext = createContext<readonly string[]>([]);
export function useCapability(capability: string) {
  return useContext(CapabilitiesContext).includes(capability);
}

export function AccessNote({ capability }: { capability: string }) {
  const allowed = useCapability(capability);
  return allowed ? null : (
    <p className="permission-note">Bu eylem için {capability} yetkisi gerekli.</p>
  );
}

export function ActionAccess({
  allowed,
  capability,
  children,
}: {
  allowed: boolean;
  capability: string;
  children: ReactNode;
}) {
  return (
    <div className="action-access">
      <fieldset disabled={!allowed}>{children}</fieldset>
      {!allowed && <p className="permission-note">Bu eylem için {capability} yetkisi gerekli.</p>}
    </div>
  );
}

/** Menü ve doğrudan bağlantı aynı görünürlük kararını kullanır. */
export function sectionVisible(key: string, role: string, capabilities: readonly string[]) {
  const required: Record<string, string> = {
    radio: 'radio.manage',
    bots: 'bots.manage',
    slot: 'slot.manage',
    photos: 'photos.review',
    system: 'system.read',
    perf: 'system.read',
    raporlar: 'report.export',
    games: 'flag.write',
  };
  if (required[key] && !capabilities.includes(required[key]!)) return false;
  const finance = [
    'economy',
    'ekonomi-varsayilan',
    'store',
    'policies',
    'daily',
    'wheel',
    'slot',
  ];
  if (role === 'FINANCE') return [...finance, 'permissions', 'audit'].includes(key);
  return capabilities.includes('finance.read') || !finance.includes(key) || key === 'policies';
}
